/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BillingAccountDetails } from '../models/BillingAccountDetails';
import type { BillingAccountMinimum } from '../models/BillingAccountMinimum';
import type { BulkIsOnAutopay } from '../models/BulkIsOnAutopay';
import type { IVRBillingAccount } from '../models/IVRBillingAccount';
import type { IVRQuery } from '../models/IVRQuery';
import { request as __request } from '../core/request';

export class BillingAccountsVService {

    /**
     * @param requestBody
     * @returns IVRBillingAccount OK
     * @throws ApiError
     */
    public static async billingAccountsVGetIvr(
        requestBody?: IVRQuery,
    ): Promise<IVRBillingAccount> {
        const result = await __request({
            method: 'POST',
            path: `/api/v3/billing-accounts/ivr`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param userId
     * @returns BillingAccountMinimum OK
     * @throws ApiError
     */
    public static async billingAccountsVGetMinimumByUserId(
        userId?: string,
    ): Promise<Array<BillingAccountMinimum>> {
        const result = await __request({
            method: 'GET',
            path: `/api/v3/billing-accounts`,
            query: {
                'userId': userId,
            },
        });
        return result.body;
    }

    /**
     * @param billingAccountId
     * @returns BillingAccountDetails OK
     * @throws ApiError
     */
    public static async billingAccountsVGetById(
        billingAccountId: string,
    ): Promise<BillingAccountDetails> {
        const result = await __request({
            method: 'GET',
            path: `/api/v3/billing-accounts/${billingAccountId}`,
        });
        return result.body;
    }

    /**
     * @param districtId
     * @returns BulkIsOnAutopay OK
     * @throws ApiError
     */
    public static async billingAccountsVGetBulkIsOnAutopay(
        districtId?: string,
    ): Promise<Array<BulkIsOnAutopay>> {
        const result = await __request({
            method: 'GET',
            path: `/api/v3/billing-accounts/bulk/is-on-autopay`,
            query: {
                'districtId': districtId,
            },
        });
        return result.body;
    }

}